"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _opacity = _interopRequireDefault(require("./opacity"));

var _accent = _interopRequireDefault(require("./accent"));

var text = {
  "delete": _accent["default"].redDark,
  disabled: _opacity["default"].black[38],
  hint: _opacity["default"].black[38],
  primary: _opacity["default"].black[87],
  secondary: _opacity["default"].black[60]
};
var _default = text;
exports["default"] = _default;